PegasusTemplate.SocialShareController = Em.ObjectController.extend();
